export default __webpack_public_path__ + "static/media/marc-olivier-jodoin.8d4e31e2.jpg";